// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement } from "@awc/XDL/Utilities";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface OrderTotalDisplaySharedStyles {
    mainContainer: GridContainerProps;
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelGridItem: GridItemProps;
    valueGridItem: GridItemProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    styledHr?: InjectableCss;
    wrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    actionsWrapper?: InjectableCss;
    button?: ButtonPresentationProps;
}

const label: TypographyPresentationProps = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    weight: fontConfig.weight.regular,
    css: css`
        letter-spacing: 0;
    `,
};
const value: TypographyPresentationProps = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    weight: fontConfig.weight.medium,
    css: css`
        letter-spacing: 0;
        margin-left: auto;
    `,
};
export const orderTotalDisplaySharedStyles: OrderTotalDisplaySharedStyles = {
    mainContainer: {
        gap: 0,
        offsetCss: css`
            row-gap: 16px;
        `,
        css: css`
            ${styledBoxStyle}
        `,
    },
    labelGridItem: {
        width: 7,
    },
    valueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 5,
    },
    label: {
        ...label,
    },
    value: {
        ...value,
    },
    totalLabel: {
        ...label,
        weight: fontConfig.weight.bold,
    },
    totalValue: {
        ...value,
        weight: fontConfig.weight.bold,
    },
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            ${styledBoxStyle}
            ${avoidBreakInsidePrintElement}
        `,
    },
    titleText: {
        variant: "h3",
        color: "primary",
        css: css`
            margin-bottom: 8px;
        `,
    },
};
